// extracted by mini-css-extract-plugin
export default {"option":"More_option__cQze4"};